<antm-page-title title="Documents" subtitle="Gérer les documents"/>

<antm-search-form (search)="search()" (reset)="reset()" [form]="form">
  <form [formGroup]="form">
    <div class="uk-grid-small" uk-grid>
      <div class="uk-width-1-2 uk-width-1-2@m">
        <antm-input
          [form]="form"
          controlName="label"
          placeHolder="Rechercher un document"
        />
      </div>
      <div class="uk-width-1-2 uk-width-1-2@m">
        <antm-date-range-picker
          [form]="form"
          startControlName="startDate"
          endControlName="endDate"
          placeholder="Choisissez la période"
        />
      </div>
    </div>
  </form>
</antm-search-form>

<table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8 uk-width-1-1 uk-margin-top">

  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Nom</th>
    <td mat-cell *matCellDef="let element"> {{ element.name }}
    </td>
  </ng-container>
  <ng-container matColumnDef="date">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Date du document</th>
    <td mat-cell *matCellDef="let element">@if (element.creationDateTime) {
      {{ element.creationDateTime | date:'dd MMMM yyyy' }}
    }
    </td>
  </ng-container>
  <ng-container matColumnDef="type">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
    <td mat-cell *matCellDef="let element">
      @if (element.type === 'DAILY') {
        Journalier
      } @else if (element.type === 'MONTHLY') {
        Mensuel
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
    <td mat-cell *matCellDef="let element">
            <i class="material-icons clickable" matTooltip="Télécharger" (click)="downloadDocument(element.id, element.name)">download</i>
      <!--        <i class="material-icons clickable" (click)="downloadManifest()" matTooltip="Télécharger le manifeste">download</i>-->
      <!--        <i class="material-icons clickable" matTooltip="Annuler le départ" (click)="downloadManifest()">close</i>-->
    </td>
  </ng-container>
  <!-- Aucune donnée -->
  <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell" [attr.colspan]="columns.length">
      <div class="no-data">
        <p>Aucun départ ne correspond à votre recherche</p>
      </div>
    </td>
  </tr>

  <tr mat-header-row *matHeaderRowDef="columns"></tr>
  <tr mat-row *matRowDef="let row; columns: columns;"></tr>
</table>
<mat-paginator [pageSizeOptions]="[10, 20, 50, 100]" showFirstLastButtons></mat-paginator>

